import { ColumnFilterElementTemplateOptions } from 'primereact/column'
import {
  Dropdown,
  DropdownChangeEvent,
  DropdownProps,
} from 'primereact/dropdown'

import i18n from '../../utils/i18n'
import { PackagingIdentifierBodyTemplate } from './PackagingIdentifierBodyTemplate'

export const PackagingIdentifierFilterTemplate = (
  options: ColumnFilterElementTemplateOptions,
) => {
  if (!options) return null

  const packagingIdentifiers: any[] = [
    'disposablePackaging',
    'reusablePackaging',
  ]

  const valueTemplate = (option: any, props: DropdownProps) => {
    if (option) {
      return PackagingIdentifierBodyTemplate(option)
    }

    return <>{props.placeholder}</>
  }

  const itemTemplate = (option: any) => PackagingIdentifierBodyTemplate(option)

  return (
    <Dropdown
      value={options.value}
      options={packagingIdentifiers}
      onChange={(e: DropdownChangeEvent) =>
        options.filterCallback(e.value, options.index)
      }
      valueTemplate={valueTemplate}
      itemTemplate={itemTemplate}
      className="p-column-filter"
      placeholder={i18n.t('common.placeholders.search')}
    />
  )
}
